import React, { Component } from "react";
import '../InitialForm/InitialFormStyleSheet.css';
import { isValidPhoneNumber, validateEmail ,validateName} from "../HWLibrary/HWUtils";
import { s360ConfigService } from "../Services/S360Config";

class TextBox extends Component {

    constructor(props) {
        super(props);
        this.messageRef = React.createRef();
    }

    render() {
        return (
            <div className="s360-initial-form-textbox-container" style={this.formInputBoxContainerStyle()} >
                <fieldset style={{"border":"1px solid silver","margin":"6px -1px","padding":".35em .625em .75em","borderRadius":"5px"}}>
                    <legend style={{"display":"block","width":"auto","padding":"2px","marginBottom":"0","fontSize":"13px","lineHeight":"inherit","color":"#333","border":"0","borderBottom":"none"}}>{this.props.item.label}</legend>
                        <input type="text" ref={this.messageRef} className="s360-initial-form-textbox-input"   style={this.formInputBoxStyle()} />
                    </fieldset>
            </div>
        );
    }

    formInputBoxContainerStyle = () => {
        return {
            color: s360ConfigService.config.designDetails.headerColor,
        }
    }

    formInputBoxStyle = () => {
        return {
            borderColor: s360ConfigService.config.designDetails.headerColor,
            color: s360ConfigService.config.designDetails.headerColor,
            backgroundColor:s360ConfigService.config.designDetails.pageBackgroundColor 
        }
    }

    onClickInput = (e) => {
        if (e.target.value === this.props.item.label) {
            e.target.style.color='rgb(0,0,0)';
            this.messageRef.current.value = "";
        }
    }

    onInputOut = (e) => {
        if (!e.target.value || !e.target.value.trim) {
            e.target.style.color='inherit';
            this.messageRef.current.value = this.props.item.label;
        }
    };

    value = () => { 
        if ((!this.messageRef.current.value || !this.messageRef.current.value.trim()) || (this.messageRef.current.value.trim() === this.props.item.label)) {
            return {}
        }
        let aValue = {};
        aValue[this.props.item.label] = this.messageRef.current.value; 
        return aValue;
    };

    validate = () => { 
        let formItemDetails = this.props.item || {};
        let isRequired = formItemDetails.required || formItemDetails.primaryField;
        let isValidationEnabled = formItemDetails.validate !== "None";
        if ((!this.messageRef.current.value || !this.messageRef.current.value.trim()) || (this.messageRef.current.value.trim() === this.props.item.label)) {
            return isRequired || isValidationEnabled ? false: true;
        }
        if (isValidationEnabled) {
            if (formItemDetails.validate.toLowerCase() === "phone") {
                return isValidPhoneNumber(this.messageRef.current.value);
             } else if (formItemDetails.validate.toLowerCase() === "email") {
                 return validateEmail(this.messageRef.current.value);
             } else if(formItemDetails.validate.toLowerCase() === "name"){
                return validateName(this.messageRef.current.value);
             }
        }
        return true;
    }

    validationErrorMessage = () => {
        return "Please enter a valid " + this.props.item.label.toLowerCase() + ".";
    }

}

export default TextBox;